export const acronymPeriodInDays = parseInt(process.env?.REACT_APP_ACRONYM_PERIOD_IN_DAYS || '', 10);
